module.exports = __webpack_public_path__ + "img/1.16_Russian_road_sign.a9bbcfa0.svg";